import React, { useEffect } from "react";
import Preloader from "./Preloader";
import $ from "jquery";

export default function Header() {

  useEffect(() => {
    $(document).ready(function ($) {
      $(window).scroll(function () {
        var scroll = $(window).scrollTop();
        if (scroll < 400) {
          $("#header-sticky").removeClass("header-sticky");
        } else {
          $("#header-sticky").addClass("header-sticky");
        }
      });
    });
  }, []);

  return (
    <>
      <Preloader />
      <header className="tp-header-height">
        {/* <!-- tp-header-area-start --> */}
        <div
          id="header-sticky"
          className="header-bottom__area header__space header-sticky-bg-2 header-bottom__transparent z-index-5"
        >
          <div className="container">
            <div className="d-flex justify-content-between align-items-center navbar">
              <div className="header-bottom__logo ps-3">
                <div className="main">
                  <a className="white-logo" href="index.html"><img src="/img/logo/billwale_white_logo.png" alt="" /></a>
                </div>
                <a className="black-logo" href="index.html"><img src="/img/logo/billwale_logo.png" alt="" /></a>
              </div>
              <div className="d-flex header-bottom__main-menu header-bottom__main-menu-3">
                <nav id="mobile-menu">
                  <ul>
                    <li>
                      <a href="/">Home</a>
                    </li>
                    <li>
                      <a href="/pricingplan">Pricing & Plans</a>
                    </li>
                    <li>
                      <a href="/about">About</a>
                    </li>
                    {/*<!-- <li><a href="service.html">Services</a></li> --> */}
                    <li>
                      <a href="/faq">FAQ</a>
                    </li>
                    <li>
                      <a href="https://8codr.com/" target="_blank" rel="noreferrer">Partner With Us</a>
                    </li>
                  </ul>
                </nav>
                <div className="header-bottom__btn pe-3">
                  <a
                    className="tp-btn-blue-sm d-none d-md-inline-block tp-btn-hover alt-color-black"
                    href="https://app.billwale.com/login" target="_blank" rel="noreferrer"
                  >
                    <span>
                      <button className="border-0 bg-transparent" type="button">
                        Log in
                      </button>
                    </span>
                    <b></b>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <!-- tp-header-area-end --> */}
      </header>
    </>
  );
}
